import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue3';
import * as Sentry from '@sentry/vue';
import { i18nVue } from 'laravel-vue-i18n';
// PrimeVue
import PrimeVue from 'primevue/config';
import Tailwind from 'primevue/passthrough/tailwind';
// Event bus
import bus from 'tiny-emitter/instance';
import { createApp, h } from 'vue';
import Button from './Shared/Button';
// Global components
import Layout from './Shared/Layout';

require('./bootstrap');

window.bus = bus;

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    title: title => `${title}`,
    setup({ el, App, props, plugin }) {
        const app = createApp({
            render: () => h(App, props),
        });

        Sentry.init({
            app,
            dsn: 'https://e06e6bef3cc634be55ad4d3b2e02254a@o4510670993686528.ingest.us.sentry.io/4510671244623872',
            sendDefaultPii: false,
            integrations: [
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
            ],
            enableLogs: true,

            // Only capture replays on errors
            replaysSessionSampleRate: 0.0,
            replaysOnErrorSampleRate: 1.0,

            // Specific errors to ignore
            ignoreErrors: ['Network Error', 'CanceledError', 'cookie', '422', 'AxiosError'],

            // Filter out 422's
            beforeSend(event, hint) {
                const status = event?.contexts?.response?.status_code;

                if (status === 422) {
                    return null;
                }
            },
        });

        return app
            .use(plugin)
            .use(PrimeVue, { unstyled: true, pt: Tailwind })
            .component('Layout', Layout)
            .component('InertiaLink', Link)
            .component('Head', Head)
            .component('Button', Button)
            .use(i18nVue, {
                lang: props.initialPage.props.locale,
                resolve: async lang => import(`../lang/${lang}.json`),
                onLoad: () => {
                    app.mount(el);
                },
            });
    },
});
